import axios from 'axios';
import { NutrientsAttribute } from 'views/feed-management/features/nutrients/types/nutrients-attribute.type';

// PUT
// Set Nutrientsattributes
// /ewosapi/v1/bestmix/Nutrientsattribute
export const putFeedManagementNutrientsAttribute = async (request: NutrientsAttribute[]): Promise<NutrientsAttribute[]> => {
  const res = await axios.put<NutrientsAttribute[]>(`/ewosapi/v1/bestmix/nutritionsattribute`, request);
  return res.data;
};
